<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="900px"
    :close-on-click-modal="false"
    append-to-body
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <div v-if="!loading && invoice" style="margin-bottom: 20px;">
        <div class="invoice-details">
          <table style="margin-right: 20px;">
            <tr>
              <td><strong>Kelt:</strong></td>
              <td>{{ invoice.issue_date | date }}</td>
            </tr>
            <tr>
              <td>Teljesítés:</td>
              <td>{{ invoice.delivery_date | date }}</td>
            </tr>
            <tr>
              <td>Fizetési határidő:</td>
              <td>{{ invoice.payment_date | date }}</td>
            </tr>
          </table>
          <table>
            <tr>
              <td>Bruttó:</td>
              <td>{{ invoice.gross_price | currency(invoice.currency_code) }}</td>
            </tr>
            <tr>
              <td>Kintlevőség:</td>
              <td>
                <el-tag
                  size="mini"
                  :type="remainingSum !== 0 ? 'danger' : 'success'"
                >
                  {{ remainingSum | currency(invoice.currency_code) }}
                </el-tag>
              </td>
            </tr>
          </table>
          <div v-if="invoice.invoice_number" style="text-align: right; width: 100%;">
            <receipt-link
              :id="invoice.id"
              :label="invoice.invoice_number"
              type="invoice"
            />
          </div>
        </div>
      </div>
      <div class="payment-container">
        <table
          class="payment-table"
          cellpadding="0"
          cellspacing="0"
        >
          <thead>
            <tr>
              <td style="width: 170px;">Összeg</td>
              <td style="width: 140px;">Dátum</td>
              <td style="min-width: 150px;">Megjegyzés</td>
              <td style="width: 150px;">Létrehozta</td>
              <td style="width: 44px;"></td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="payment in payments"
              :key="payment.id"
            >
              <td>
                <el-input
                  v-model="payment.amount"
                  size="mini"
                  type="number"
                >
                  <template slot="append">{{ invoice.currency_code }}</template>
                </el-input>
              </td>
              <td>
                <el-date-picker
                  size="mini"
                  v-model="payment.payment_date"
                  type="date"
                  style="width: 100%;"
                  :clearable="false"
                  format="yyyy. MM. dd."
                  value-format="yyyy-MM-dd"
                  :picker-options="{ firstDayOfWeek: 1 }"
                />
              </td>
              <td>
                <el-input
                  size="mini"
                  v-model="payment.comment"
                  type="textarea"
                />
              </td>
              <td>{{ payment.creator_user_name }}</td>
              <td style="text-align: right;">
                <el-button
                  size="mini"
                  icon="el-icon-delete"
                  type="danger"
                  @click="deletePayment(payment)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="add-item"
      >
        <el-button
          icon="el-icon-plus"
          size="mini"
          @click="addPayment"
        >
          Jóváírás hozzáadása
        </el-button>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        Mentés
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import rules from './rules';
import ReceiptLink from '../../utils/ReceiptLink';

export default {
  components: { ReceiptLink },
  props: {
    invoiceId: {
      type: Number,
      default() {
        return 0;
      }
    },
    onClose: {
      type: Function,
    },
  },
  data() {
    return {
      loading: false,
      buttonLoading: false,
      invoice: {},
      deletedPaymentIds: [],
      payments: [],
      rules,
    };
  },
  computed: {
    paidSum() {
      let sum = 0;
      this.payments.forEach(p => sum += parseFloat(p.amount || 0));
      return sum;
    },
    remainingSum() {
      let sum = 0;
      this.payments.forEach(p => sum += parseFloat(p.amount || 0));
      return this.invoice.gross_price - sum;
    },
    loggedInUser() {
      return this.$store.getters['auth/user'];
    },
    title() {
      if (this.invoice && this.invoice.invoice_number) {
        return `Jóváírások (${this.invoice && this.invoice.invoice_number})`;
      } else {
        return 'Jóváírások betöltése folyamatban...';
      }
    },
  },
  async mounted() {
    this.loading = true;
    const requests = [];
    await Promise.all(requests);
    if (this.invoiceId) {
      this.invoice = await this.$store.dispatch('invoice/fetchPayments', this.invoiceId);
      this.payments = await axios.get('api/invoice-payments/invoice/' + this.invoiceId);
    }
    this.loading = false;
  },
  methods: {
    addPayment() {
      this.payments.push({
        key: Math.random().toString(36).substring(7),
        invoice_id: this.invoice.id,
        invoice_number: this.invoice.invoice_number,
        payment_date: new Date(),
        amount: this.remainingSum,
        comment: '',
        creator_user_name: this.loggedInUser.full_name,
      });
    },
    deletePayment(p) {
      const checkId = p.id || p.key;
      this.payments = this.payments.filter(payment => payment.id !== checkId && payment.key !== checkId);
      if (p.id) {
        this.deletedPaymentIds.push(p.id);
      }
    },
    async store() {
      this.buttonLoading = true;
      await axios.post('api/invoice-payments', {
        invoice_id: this.invoice.id,
        payments: this.payments,
        deleted_payment_ids: this.deletedPaymentIds,
      });
      this.$store.dispatch('invoice/fetchAll');
      if (this.onClose) {
        this.onClose()
      } else {
        this.$router.replace('/sales/invoices');
      }
      this.buttonLoading = false;
    },
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          if (this.onClose) {
            this.onClose()
          } else {
            this.$router.replace('/sales/invoices');
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss">
  $borderColor: #EBEEF5;
  $headerColor: #909399;

  .payment-container {
    .payment-table {
      border-left: 1px solid $borderColor;
      border-top: 1px solid $borderColor;
      width: 100%;

      td {
        border-right: 1px solid $borderColor;
        border-bottom: 1px solid $borderColor;
        padding: 12px 10px;
        margin-bottom: -1px;
        vertical-align: top;
      }

      .payment-table__header {
        color: $headerColor;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .add-item {
    border-bottom: 1px dotted #dadfe7;
    border-left: 1px dotted #dadfe7;
    border-right: 1px dotted #dadfe7;
    text-align: center;
    padding: 10px;
  }
  .invoice-details {
    display: flex;
    table {
      width: 100%;
      tr {
        td:first-child {
          font-weight: bold;
        }
        td {
          padding: 3px 15px 3px 0;
        }
      }
    }
  }
</style>
